import { graphqlShopifyStorefront } from "@repo/graphql-shopify-storefront";

export const ShopPolicy_Fragment = graphqlShopifyStorefront(`
  fragment ShopPolicy on ShopPolicy {
    body
    handle
    id
    title
    url
  }
`);
